<template>
  <div>
    <base-info-card
      v-for="feature in features"
      :key="feature"
      :title="feature"
    >
      <a
        :text="feature"
        class="mb-8 grey--text text-body-1 d-block text-none"
        href="#"
        v-html="`&rsaquo; ${feature} ansehen`"
      />
    </base-info-card>
  </div>
</template>

<script>
  export default {
    name: 'SectionFeaturesAlt',

    data: () => ({
      features: [
        'Buchhaltung',
        'Personalwesen',
        'Unternehmensberatung',
        'Steuerberatung',
      ],
    }),
  }
</script>
